export * from "-!../../node_modules/babel-loader/lib/index.js!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HelpDocumentsInfo.vue?vue&type=template&id=3c35760b"


//////////////////
// WEBPACK FOOTER
// ./Scripts/Components/HelpDocumentsInfo.vue?vue&type=template&id=3c35760b
// module id = 626
// module chunks = 0